<!--  -->
<template>
  <div id="XyContent">
    <div class="cell-item">
      <label class="item-left">调课原因</label>
      <div class="item-right" v-cloak>{{applyInfo.Description}}</div>
    </div>
    <div class="cell-item">
      <div v-for="(item,index) in applyInfo.Data" :key="index">
        <div class="item-block">
          <h3 class="h-title" v-cloak>{{item.StudentOrganizationFullName}}</h3>
          <div class="time-item">
            <span class="round1"></span>
            <span v-cloak>
              <span class="week" v-if="item.SourceClassDate !=='0001-01-01'">{{item.SourceClassDate}}</span>
              <span>第{{item.SourceWeek}}周{{item.SourceWeekName}}{{item.SourceInfo}}</span>
            </span>
          </div>
          <div class="time-item">
            <span class="round2"></span>
            <span v-cloak>
              <span class="week" v-if="item.TargetClassDate !=='0001-01-01'">{{item.TargetClassDate}}</span>
              <span>第{{item.TargetWeek}}周{{item.TargetWeekName}}{{item.TargetInfo}}</span>
            </span>
          </div>
          <div class="subject-teacher" v-cloak v-if="item.SourceSubjectName  && item.SourceTeacherNames">
            <span>{{item.SourceSubjectName}}</span>
            <span class="week">{{item.SourceTeacherNames}}</span>
          </div>
        </div>
        <div class="divider-line" v-if="applyInfo.Data.length !== (index+1)"></div>
      </div>
    </div>
    <!--<div class="cell-item">
        <label class="item-left">有效期</label>
        <div class="item-right" v-cloak>{{applyData.EffectiveWeek}}周</div>
    </div>-->
    <!--0申请中 1待审批 2已通过 3未通过 4已拒绝 5已过期 6已撤回-->
    <van-popup v-model="isShow" position="bottom" :style="{ height: '50%' }">
      <div class="approval-box-bg" @click.self="closeFrame">
        <div class="approval-box">
          <p>审批结果</p>
          <div class="approval-btns">
            <span v-bind:class="state?'':'current'" class="disagree" @click="state = false">拒绝</span>
            <span v-bind:class="state?'current':''" @click="state = true">同意</span>
          </div>
          <p>审批意见</p>
          <div class="approval-textarea">
            <van-field v-model="opinions" rows="8" type="textarea" placeholder="请输入审批意见" maxlength="100" show-word-limit />
          </div>
          <div class="bottom-btns clearfix">
            <div class="fl" @click="closeFrame">取消</div>
            <div class="fr commit" @click="submit">确定</div>
          </div>
          <!--取消审批功能--->
        </div>
      </div>
    </van-popup>
    <div v-if="!isShow" class="posi-appro-btn" @click="isShow = true">审批</div>

  </div>
</template>

<script>

 
import xyapi from "@/common/api";
export default {
  components: {},
  data () {
    return {
      radio4: "0",
      applyData: {
        EffectiveWeek: 1
      },
      applyInfo: {
        Description: "",
        Data: [],
        SubstituteStatus: ""
      },
      state: false, //同意、拒绝
      opinions: "",
      isShow: false
    };
  },
  created: function () {
    this.applyData = this.$route.query;
    this.getAdjustInfo();
  },
  computed: {
    apipath () {
      return this.xyMApi;
    }
  },
  mounted: function () { },
  methods: {
    //调课
    getAdjustInfo () {
      this.xy.loading();
      var that = this;
      xyapi.get(this.apipath + "/api/ClasstableGenerateForTeacherAdjustmentApply/GetTeaherApplyInfo", {
        appilyID: that.applyData.ID
      }).then(res => {
        that.xy.unloading();
        if (res.success) {
          that.applyInfo = res.data;
        }
      }).catch(err => {
        that.$toast.fail(err.msg);
        that.xy.unloading();
      });
    },
    //审核内容
    submit: function () {
      if (this.applyData.IsCrossWeeks) {
        //跨周
        this.crossCycleApply();
      } else {
        //单周
        this.oneCycleApply();
      }
    },
    oneCycleApply: function () {
      //单周调课提交
      var that = this;
      if (this.opinions.length > 100) {
        that.$toast.fail("审批意见限制100字符");
        return false;
      }
      this.xy.loading();
      xyapi.post(this.apipath + "/api/ClassTableGenerateForTeacherApplyExamine/OneCycleApply", {
        ID: that.applyData.ID,
        Status: that.state,
        OpinionDescription: that.opinions
      }).then(res => {
        that.xy.unloading();
        if (res.success) {
          that.$toast.success("审批成功");
          that.back();
        }
      }).catch(err => {
        that.$toast.fail(err.msg);
      });
    },
    crossCycleApply: function () {
      //跨周调课提交
      var that = this;
      this.xy.loading();
      xyapi.post(this.apipath + "/api/ClassTableGenerateForTeacherApplyExamine/CrossCycleApply", {
        ID: that.applyData.ID,
        Status: that.state,
        OpinionDescription: that.opinions
      }).then(res => {
        that.xy.unloading();
        if (res.success) {
          that.$toast.success("审批成功");
          that.back();
        }
      }).catch(err => {
        that.$toast.fail(err.msg);
      });
    },

    //关闭审核弹框
    closeFrame: function () {
      this.isShow = false;
    },
    //关闭
    back: function () {
      this.$router.push({ path: "/home/ApprovalTable" });
    }
  }
};
</script>
<style lang='less' scoped>
#XyContent {
  .cell-item {
    background: #fff;
    padding: 24px 10px 24px 20px;
    font-size: 14px;
    color: #333333;
    margin-top: 15px;
    .item-left {
      display: inline-block;
      vertical-align: top;
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
    }
    .item-right {
      font-size: 28px;
      margin-left: 26px;
      display: inline-block;
      color: #666666;
    }
    .h-title {
      font-size: 28px;
      margin-bottom: 32px;
    }
    .time-item {
      font-size: 26px;
      color: #666666;
      margin-bottom: 32px;
      .round1,
      .round2 {
        width: 13px;
        height: 13px;
        border: 2px solid rgba(226, 226, 227, 1);
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        background-color: transparent;
      }
      .round1 {
        background-color: #e2e2e3;
      }
      .week {
        margin: 0 16px;
      }
    }
    .subject-teacher {
      background: rgba(246, 246, 247, 1);
      border-radius: 14px 0px 14px 0px;
      padding: 10px 29px 10px 19px;
      display: inline-block;
      font-size: 24px;
      color: #666666;
      .week {
        margin: 0 16px;
      }
    }
    .divider-line {
      height: 1px;
      background: #eeeeee;
      margin: 16px 0;
    }
  }
  .posi-appro-btn {
    position: fixed;
    right: 20px;
    bottom: 20px;
    line-height: 120px;
    text-align: center;
    font-size: 32px;
    color: #fff;
    width: 120px;
    height: 120px;
    box-shadow: 0px 4px 12px 0px rgba(52, 101, 241, 0.5);
    border-radius: 50%;
    background: linear-gradient(
      90deg,
      rgba(65, 150, 255, 1) 0%,
      rgba(53, 102, 252, 1) 100%
    );
    border-radius: 50%;
  }

  .approval-box {
    width: 100%;
    padding: 20px;
    background: #fff;
    color: #333;
    border-radius: 16px 16px 0 0;
    p {
      margin: 16px;
    }
    .approval-btns {
      padding: 8px 0;
      overflow: hidden;
      span {
        padding: 16px 50px;
        text-align: center;
        display: inline-block;
        background: #f2f2f2;
        color: #999;
        border-radius: 50px;
      }

      .current {
        border: none;
        background: #4196ff;
        color: #fff;
      }
      .disagree {
        margin-right: 20px;
      }
    }
    .bottom-btns {
      width: 90%;
      margin: 0 auto;
      position: absolute;
      bottom: 16px;
      div {
        padding: 16px 70px;
        text-align: center;
        background: #f2f2f2;
        color: #666;
        border-radius: 70px;
        font-size: 26px;
        .commit {
          background: #4196ff;
          color: #fff;
        }
      }
    }
  }
}
</style>
<style lang="less" >
textarea {
  padding: 20px !important;
  border: none !important;
  border-radius: 16px !important;
  width: 100%;
  height: 100%;
  background: #f5f5f5 !important;
  color: #666;
  font-family: arial, sans-serif;
}
textarea::-webkit-input-placeholder {
  font-family: arial, sans-serif;
  color: #999;
}
</style>

